import { Component, OnInit } from '@angular/core';

import { ErrorStrings, Genders, ValidationPatterns } from 'src/app/constants/form.constants';
import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { RedirectionParams, RedirectionService } from 'src/app/services/redirection/redirection.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-update-gender',
  templateUrl: './update-gender.component.html',
  styleUrls: ['./update-gender.component.scss']
})
export class UpdateGenderComponent implements OnInit {
  errorStrings = ErrorStrings;
  loading = false;
  alert: Alert = null;
  user: User;
  redirectParams?: RedirectionParams;
  public Genders = Genders;
  newGender: string;
  existingGender: string;
  useRebrandedLayout: boolean;

  validationPatterns = ValidationPatterns;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private redirectionService: RedirectionService,
    private featureFlagService: FeatureFlagsService
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  save(form: NgForm) {
    this.closeAlert();
    this.loading = true;

    this.userService.saveGender(this.newGender)
      .subscribe({
        next: updatedUser => {
          this.user = updatedUser;
          this.existingGender = this.getExistingGender();
          form.controls.gender.reset();
          this.newGender = '';

          this.alert = {
            type: 'success',
            message: 'Your personal information has been updated.'
          };
          this.loading = false;

          if (this.redirectParams) {
            this.router.navigate(this.redirectParams.l, { queryParams: this.redirectParams.q, fragment: this.redirectParams.f });
          }
        },
        error: err => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.loading = false;
            this.alert = {
              type: 'danger',
              message: 'There was a problem updating your gender.'
            };
          } else {
            this.loading = false;
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
          }
        }
      })
  }

  closeAlert() {
    this.alert = null;
  }

  getExistingGender(): string {
    return this.user.gender;
  }

  ngOnInit(): void {
    this.existingGender = this.getExistingGender();

    // Setting redirection to be used when gender is saved or when pressing back
    this.redirectParams = this.redirectionService.getParams(this.route.snapshot.queryParams.r);
  }
}
